import React, { Component } from "react";

class EmailLayout extends Component {
  render() {
    return (
      <div>
        <meta name="viewport" content="width=device-width" />
        <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
        <title>{this.props.t("Emails.emailSubject")}</title>
        <style
          media="all"
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n        @media all {\n            .btn-primary table td:hover {\n                background-color: #34495e !important;\n            }\n            .btn-primary a:hover {\n                background-color: #34495e !important;\n                border-color: #34495e !important;\n            }\n        }\n\n        @media all {\n            .btn-secondary a:hover {\n                border-color: #34495e !important;\n                color: #34495e !important;\n            }\n        }\n\n        @media only screen and (max-width: 720px) {\n            table[class=body] h1 {\n                font-size: 28px !important;\n                margin-bottom: 10px !important;\n            }\n            table[class=body] h2 {\n                font-size: 22px !important;\n                margin-bottom: 10px !important;\n            }\n            table[class=body] h3 {\n                font-size: 16px !important;\n                margin-bottom: 10px !important;\n            }\n            table[class=body] p,\n            table[class=body] ul,\n            table[class=body] ol,\n            table[class=body] td,\n            table[class=body] span,\n            table[class=body] a {\n                font-size: 16px !important;\n            }\n            table[class=body] .wrapper,\n            table[class=body] .article {\n                padding: 10px !important;\n            }\n            table[class=body] .content {\n                padding: 0 !important;\n            }\n            table[class=body] .container {\n                padding: 0 !important;\n                width: 100% !important;\n            }\n            table[class=body] .header {\n                margin-bottom: 10px !important;\n            }\n            table[class=body] .main {\n                border-left-width: 0 !important;\n                border-radius: 0 !important;\n                border-right-width: 0 !important;\n            }\n            table[class=body] .btn table {\n                width: 100% !important;\n            }\n            table[class=body] .btn a {\n                width: 100% !important;\n            }\n            table[class=body] .img-responsive {\n                height: auto !important;\n                max-width: 100% !important;\n                width: auto !important;\n            }\n            table[class=body] .alert td {\n                border-radius: 0 !important;\n                padding: 10px !important;\n            }\n            table[class=body] .span-2,\n            table[class=body] .span-3 {\n                max-width: none !important;\n                width: 100% !important;\n            }\n            table[class=body] .receipt {\n                width: 100% !important;\n            }\n        }\n\n        @media all {\n            .ExternalClass {\n                width: 100%;\n            }\n            .ExternalClass,\n            .ExternalClass p,\n            .ExternalClass span,\n            .ExternalClass font,\n            .ExternalClass td,\n            .ExternalClass div {\n                line-height: 100%;\n            }\n            .apple-link a {\n                color: inherit !important;\n                font-family: inherit !important;\n                font-size: inherit !important;\n                font-weight: inherit !important;\n                line-height: inherit !important;\n                text-decoration: none !important;\n            }\n        }\n    ",
          }}
        />
        <table
          border={0}
          cellPadding={0}
          cellSpacing={0}
          className="body"
          style={{
            borderCollapse: "separate",
            msoTableLspace: "0pt",
            msoTableRspace: "0pt",
            width: "100%",
            backgroundColor: "#f6f6f6",
          }}
          width="100%"
          bgcolor="#f6f6f6"
        >
          <tbody>
            <tr>
              <td
                style={{
                  fontFamily: "sans-serif",
                  fontSize: 14,
                  verticalAlign: "top",
                }}
                valign="top"
              >
                &nbsp;
              </td>
              <td
                className="container"
                style={{
                  fontFamily: "sans-serif",
                  fontSize: 14,
                  verticalAlign: "top",
                  display: "block",
                  margin: "0 auto !important",
                  maxWidth: 780,
                  padding: 10,
                  width: 780,
                }}
                width={780}
                valign="top"
              >
                <div
                  className="content"
                  style={{
                    boxSizing: "border-box",
                    display: "block",
                    margin: "0 auto",
                    maxWidth: 780,
                    padding: 10,
                  }}
                >
                  <table
                    className="main"
                    style={{
                      borderCollapse: "separate",
                      msoTableLspace: "0pt",
                      msoTableRspace: "0pt",
                      width: "100%",
                      background: "#fff",
                      borderRadius: 3,
                    }}
                    width="100%"
                  >
                    {/* START MAIN CONTENT AREA */}
                    <tbody>
                      <tr>
                        <td
                          className="wrapper"
                          style={{
                            fontFamily: "sans-serif",
                            fontSize: 14,
                            verticalAlign: "top",
                            boxSizing: "border-box",
                            padding: 20,
                          }}
                          valign="top"
                        >
                          <table
                            border={0}
                            cellPadding={0}
                            cellSpacing={0}
                            style={{
                              borderCollapse: "separate",
                              msoTableLspace: "0pt",
                              msoTableRspace: "0pt",
                              width: "100%",
                            }}
                            width="100%"
                          >
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    fontFamily: "sans-serif",
                                    fontSize: 14,
                                    textAlign: "center",
                                  }}
                                >
                                  <img
                                    style={{ width: "180px", marginBottom: 20 }}
                                    width="180px"
                                    alt="VP LOGO"
                                    src="https://keycloak.justknowledge.ca/auth/resources/3.4.3.final/login/VirtualProctoring/img/email_logo.png"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily: "sans-serif",
                                    fontSize: 14,
                                    textAlign: "left",
                                    verticalAlign: "top",
                                  }}
                                  valign="top"
                                >
                                  <hr
                                    style={{
                                      borderColor: "black",
                                      width: "60%",
                                    }}
                                  />
                                </td>
                              </tr>
                              <table>
                                <tr>
                                  <td
                                    style={{
                                      paddingLeft: "12%",
                                      paddingRight: "12%",
                                      fontFamily: "sans-serif",
                                      fontSize: 14,
                                      textAlign: "left",
                                      verticalAlign: "top",
                                    }}
                                    valign="top"
                                  >
                                    {this.props.content}
                                  </td>
                                </tr>
                              </table>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                      {/* END MAIN CONTENT AREA */}
                    </tbody>
                  </table>
                  {/* START FOOTER */}
                  <div
                    className="footer"
                    style={{
                      clear: "both",
                      paddingTop: 10,
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    <table
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                      style={{
                        borderCollapse: "separate",
                        msoTableLspace: "0pt",
                        msoTableRspace: "0pt",
                        width: "100%",
                      }}
                      width="100%"
                    >
                      <tbody>
                        <tr>
                          <td
                            className="content-block"
                            style={{
                              fontFamily: "sans-serif",
                              verticalAlign: "top",
                              paddingTop: 10,
                              paddingBottom: 10,
                              fontSize: 12,
                              color: "#999999",
                              textAlign: "center",
                            }}
                            valign="top"
                            align="center"
                          >
                            <br />
                            <span
                              className="apple-link"
                              style={{
                                fontWeight: "bold",
                                textDecoration: "underline",
                                color: "#999999",
                                fontSize: 14,
                                textAlign: "center",
                              }}
                            >
                              {this.props.t("Emails.supportCenter")}
                            </span>
                            <br />
                            <a
                              mailto="support@eproctorcanada.com"
                              style={{
                                textDecoration: "underline",
                                color: "#999999",
                                fontSize: 12,
                                textAlign: "center",
                              }}
                            >
                              support@eproctorcanada.com
                            </a>
                            <br />
                            <span
                              className="apple-link"
                              style={{
                                color: "#999999",
                                fontSize: 12,
                                textAlign: "center",
                              }}
                            >
                              {this.props.t("Emails.tollFree")}:
                              <a
                                href="tel:+18445952561"
                                style={{
                                  textDecoration: "underline",
                                  color: "#999999",
                                  fontSize: 12,
                                  textAlign: "center",
                                }}
                              >
                                1-844-595-2561
                              </a>
                            </span>
                            <br />
                            <br />
                            <span
                              style={{
                                color: "#999999",
                                fontSize: 12,
                                textAlign: "center",
                              }}
                            >
                              PO Box 303
                            </span>
                            <br />
                            <span
                              style={{
                                color: "#999999",
                                fontSize: 12,
                                textAlign: "center",
                              }}
                            >
                              Charlottetown, PE C1A 7K7
                            </span>
                            <br />
                            <span
                              style={{
                                color: "#999999",
                                fontSize: 12,
                                textAlign: "center",
                              }}
                            >
                              Canada
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {/* END FOOTER */}
                  {/* END CENTERED WHITE CONTAINER */}
                </div>
              </td>
              <td
                style={{
                  fontFamily: "sans-serif",
                  fontSize: 14,
                  verticalAlign: "top",
                }}
                valign="top"
              >
                &nbsp;
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default EmailLayout;
